import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections';
import { LASUser } from '@adornis/digitale-helden-shared/db/las-user';
import { Permissions } from '@adornis/digitale-helden-shared/db/permissions';
import { getLASUserByEmail } from '@adornis/digitale-helden-shared/features/users/api/getUserByEmail';
import { AdornisRoles } from '@adornis/users/db/a-roles';
import { loginWithPassword } from '@adornis/users/db/a-user';
import { AdornisRoleToContextsWrapper } from '@adornis/users/db/roleToContextsWrapper';
import type { UserPermission } from '@adornis/users/db/types';

export const loginMarketingUser = registerQuery({
  type: () => String,
  operationName: 'loginMarketingUser',
  resolve: (username: string, password: string) => {
    return async () => {
      const user = await getLASUserByEmail(username)({ roles: AdornisRoleToContextsWrapper.allFields });
      if (!user) throw new Error('User not found');

      const rawRolesCollection = await getRawCollection<AdornisRoles>(AdornisRoles._collectionName);
      const roles = await rawRolesCollection.find({ name: { $in: user.roles.map(r => r.name) } }).toArray();
      const permissions = roles.flatMap(r => r.permissions);

      if (!permissions.includes(Permissions.TeamPermission.VIEW as any as UserPermission)) {
        throw new Error('User does not have permission to login.');
      }

      const [userID, _] = await loginWithPassword(username, password, LASUser)();
      return userID;
    };
  },
  params: [
    { name: 'username', type: () => String },
    { name: 'password', type: () => String },
  ],
});
